/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import '../bootstrap';
import '../common';
import './jquery.form';
// import Vue from 'vue';
import './jquery.min';
import './swiper.jquery.min';
import './Simple-Slider';
import './app-sidebar';
import './jquery.matchHeight-min';
import './notification-sidebar';
import './perfect-scrollbar.jquery.min';
import './prism.min';
import './screenfull.min';
import './frontend';
import './alarms';
import './notifications';
import './sensor-reads';
import './fuel-tank-sensor-reads';
import './fuel-lidar-sensor-reads';
import './generator-sensor-reads';
import './circuit-breaker-sensor-reads';
import './fuel-quality-sensor-reads';
import './tracker-unit-sensor-reads';
import './flow-meter-sensor-reads';
import './dynamic-sensor-reads';
import './sensor-types';
import './sensors';
import './assets-distribution-maps';
import './vendors';
import './zones';
import './sites';
import './asset-types';
import './assets';
import './asset-type-categories';
import './units';
import './buildings';
import './users';
import './building-types';
import './sensor-attribute-renderers';
import './sensor-categories';
import './dynamic_form';
import './dynamic_form_with_count';
import './en-link-mod-bus-sensor-reads';
import './people-counter-sensor-reads';
import './color-maps';
import './advanced-generator-monitor-sensor-reads';
import './advanced-power-meter-sensor-reads';
import './liquefied-petroleum-gas-sensor-reads';
import './pressure-sensor-reads';
import './new-generator-stats-sensor-reads';
import './lidar-cement-measuring-sensor-reads';
import './lidar2-cement-measuring-sensor-reads';
import './pre-calculated-cement-silo-cement-measuring-sensor-reads';
import './columns-based-sensor-reads';
import './regions';
import './states';
import './clusters';
import './hk-dual-pressure-sensor-reads';

import maplibregl from 'maplibre-gl';

import './map';

import ApexCharts from 'apexcharts'
import Sortable from 'sortablejs';
// Livewire 4 bundles Alpine; use its copy so only one Alpine instance runs (layout must use @livewireScriptConfig, not @livewireScripts)
import { Livewire, Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm'

window.ApexCharts = ApexCharts;

const loadedCharts = new Set();
const updateSeries = ApexCharts.prototype.updateSeries;
ApexCharts.prototype.updateSeries = function (...args) {
    loadedCharts.add(this);
    this.w.config.noData.text = this.noDataText || 'No data for this period';
    return updateSeries.apply(this, args);
};

$(document).on('change', '.filterChart', function () {
    const component = this.closest('[wire\\:id]');
    loadedCharts.forEach((chart) => {
        if (!chart.el.isConnected) {
            loadedCharts.delete(chart);
        } else if (component && component.contains(chart.el) && chart.w.globals.noData && chart.w.config.noData.text) {
            chart.updateOptions({noData: {text: ''}}, false, false);
        }
    });
});

// Defaults for every chart; colors come from the theme's :root variables
const themeVar = (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim();
window.Apex = {
    chart: {
        fontFamily: themeVar('--font-family-sans-serif'),
    },
    noData: {text: '', style: {color: '#6B6B6B', fontSize: '13px'}},
    // Hourly charts have ~25 labels: keep them flat and drop the ones that would overlap
    xaxis: {labels: {rotate: 0, hideOverlappingLabels: true}},
    colors: ['--primary', '--info', '--success', '--warning', '--danger', '--secondary'].map(themeVar),
    grid: {borderColor: '#EBEBEB', strokeDashArray: 4},
};

window.maplibregl = maplibregl;

window.Sortable = Sortable;

// window.Vue = Vue;
window.Alpine = Alpine
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
//
// const app = new Vue({
//     el: '#app',
// });

$('#create-modal').on('hidden.bs.modal', function () {
    document.dispatchEvent(new Event('create-modal-closed'));
});

Livewire.on('toastr-success', function (data) {
    XonBoard.Utils.handleSuccess(data);
});

Livewire.on('toastr-failure', function (data) {
    XonBoard.Utils.handleError(data);
});

Alpine.store('passwordModal', {
    action: null,
    show(action) {
        $('#password-modal').modal('show');
        this.action = action;
    },
});

const notificationStoreName = 'notifications';
Alpine.store(notificationStoreName, {
    has_more: false,
    notifications: [],
    alarms_ids: [],
    notifications_count: null,
    is_loading: true,
    total_count: 0,
    last_notification_date: null,
    refresh(data) {
        this.has_more = data.has_more;
        this.notifications = data.notifications;
        this.notifications_count = data.notifications_count;
        this.last_notification_date = data.last_notification_date;
        this.total_count = data.total_count;
        this.is_loading = false;
        this.refreshAlarms(data.alarms_ids);
    },
    refreshAlarms(alarms) {
        this.alarms_ids = alarms;

        if (!this.hasAlarms()) {
            XonBoard.Alarms.stopNow();
        }
    },
    emptyNotifications() {
        return !this.total_count || this.total_count == 0;
    },
    more(data) {
        this.has_more = data.has_more;
        this.total_count = data.total_count;
        this.notifications = this.notifications.concat(data.notifications);
        this.last_notification_date = data.last_notification_date;
        this.is_loading = false;
    },
    addAlarm(alarm_id) {
        this.alarms_ids.push(alarm_id);
    },
    removeAlarm(alarm_id) {
        this.alarms_ids = this.alarms_ids.filter(function (e) {
            return e != alarm_id;
        });

        if (this.hasAlarms()) {
            return;
        }

        XonBoard.Alarms.stopNow();
    },
    hasAlarms() {
        return this.alarms_ids.length > 0;
    },
    stopAllAlarms() {
        this.alarms_ids = [];
    },
});

Alpine.store('zoneSiteData', function () {
    return {
        zoneSelector: function () {
            return this.$refs.zoneSelector;
        },
        siteSelector: function () {
            return this.$refs.siteSelector;
        },
        baseUrl: function () {
            return $(this.siteSelector()).data('base-url');
        },
        zoneSiteInit: function (isSiteEnabled = false) {
            var self = this;

            var site = $(this.siteSelector());
            if (!isSiteEnabled) {
                site.prop('disabled', true);
            }

            $(this.zoneSelector()).on('change', function () {
                $(self.siteSelector()).val(null).change();

                if (!this.value) {
                    $(self.siteSelector()).prop('disabled', true);
                    return;
                }

                $(self.siteSelector()).data('url', self.baseUrl() + '?zone_id=' + $(self.zoneSelector()).val());
                $(self.siteSelector()).prop('disabled', false);
            });
        }
    };
});

Livewire.on('more-notifications', function (data) {
    Alpine.store(notificationStoreName).more(data);
});

Livewire.on('refresh-notifications', function (data) {
    Alpine.store(notificationStoreName).refresh(data);
});

Alpine.data('sensorTypeData', (
        is_mergeable = false,
        payload_samples = [],
        partials_per_read_count = 1,
    ) => {
    return {
            is_mergeable: is_mergeable,
            partials_per_read_count: partials_per_read_count,
            isMergeable() {
                return this.is_mergeable == true || this.is_mergeable == 1;
            },
            payload_samples: [...payload_samples],
            refill(
                is_mergeable = false,
                payload_samples = [],
                partials_per_read_count = 1,
            ) {
                this.is_mergeable = is_mergeable;
                this.payload_samples = [...payload_samples];
                this.partials_per_read_count = partials_per_read_count;
            },
            init() {
                this.$watch('is_mergeable', value => this.watchIsMergeable(value));
                this.$watch('partials_per_read_count', value => this.generateSamples());

                if (this.payload_samples.length == 0) {
                    this.generateSamples();
                } else {
                    this.addIdsToSamples();
                }
            },
            watchIsMergeable(value) {
                if (value == 0) {
                    this.partials_per_read_count = 1;
                }

                this.generateSamples();
            },
            generateSamples() {
                this.payload_samples = [];

                for (var i = 0; i < this.partials_per_read_count; i++) {
                    this.payload_samples.push(
                        {
                            key: new Date().getTime() + this.payload_samples.length,
                            payload: null,
                            port: null,
                        },
                    );
                }

                this.payload_samples = [...this.payload_samples];
            },
            addIdsToSamples() {
                for (var i = 0; i < this.payload_samples.length; i++) {
                    this.payload_samples[i].key = new Date().getTime() + this.payload_samples.length;
                }

                this.payload_samples = [...this.payload_samples];
            },
        };
    },
);

Livewire.start()
